module.exports = __webpack_public_path__ + "img/logo_eeirh.3d8fa570.png";